import { TextLinkWidget } from '@tableau/widgets';
import React = require('react');
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~commonInfra/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';
import { moveContents } from '~src/projects/actions/MoveContentsAction';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { INamedItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { ContentDetailSection, DetailEditButton } from './ContentDetailSection';


interface LocationDetailSectionOwnProps {
  readonly content: IContentInfo<ExplorableItemType>;
  readonly location: string;
  readonly project: INamedItemInfo;
  readonly isActionEnabled: boolean;
  readonly urls: SpacesSiteUrls;
  readonly incrementRouterSpaceReactKey: () => void;
  readonly isOwner: boolean;
}

interface LocationDetailSectionDispatchProps {
  readonly moveContent: (items: IContentInfo<ExplorableItemType>[]) => void;
}

export type LocationDetailSectionProps = LocationDetailSectionOwnProps & LocationDetailSectionDispatchProps;

export function LocationDetailSection(props: LocationDetailSectionProps): JSX.Element {
  let href = null;
  let name = null;
  if(props.location === 'PERSONAL_SPACE') {
   href = props.isOwner? props.urls.personalSpaceUrl() : null;
   name = Messages.personalSpaceTitle();
  }else {
    href = props.project && props.urls.projectUrl(props.project.id);
    name = props.project && props.project.name;
  }

  const moveContent = () => {
    return new Promise(() => {
      props.moveContent([props.content]);
    });
  };

  const detail = (props.isOwner || props.project) ?
  href && name && <TextLinkWidget
  testId='location-name'
  href={href}
  children={name}
  />: Messages.personalSpaceTitle();
  return (
    <ContentDetailSection
      header={Messages.column_location()}
      testId={'location'}
      detail={detail}
      isActionAllowed={props.isActionEnabled}
      action={
        <DetailEditButton
          buttonLabel={Messages.move_action()}
          buttonTestId={'move-to-container'}
          onClickAction={() => {
            moveContent().then(() => {
              props.incrementRouterSpaceReactKey();
            });
          }}
        />
      }
    />
  );
}

const mapDispatchToProps: MapDispatchToProps<LocationDetailSectionDispatchProps> = (dispatch) => bindActionCreators({
  moveContent: moveContents,
}, dispatch);

export const ConnectedLocationDetailSection: React.ComponentClass<LocationDetailSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(LocationDetailSection);
